import styled from 'styled-components';

import SectionFrame from 'packages/smart-home-support/pages/homepage/components/SectionFrame';

import BREAK_POINTS from '@soluto-home-web/platform-common-ui/styling/media-queries';

export default styled(SectionFrame)`
  display: flex;
  align-items: flex-start;

  flex: 4;
  background-image: ${(props: { src: any }) =>
    `linear-gradient(0deg,rgba(27,27,27,0) 61%,rgba(4,4,4,0.65) 100%), url(${props.src})`};
  background-size: cover;
  background-position-y: top;
  background-position-x: right;
  height: 330px;

  @media ${BREAK_POINTS.mobileBig} {
    background-position-y: center;
    background-position-x: center;
    height: 400px;
  }

  @media ${BREAK_POINTS.tablet} {
    height: auto;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/ValuePropositionImageContainer.tsx